import { Button, Flex, Input } from '@components';
import { Dialog } from '@mui/material';
import { ChangeEvent } from 'react';
import { NewItemFormContainer } from './NewCustomerForm.styles';
import { FormattedMessage } from 'react-intl';

export interface NewItemDialogProps {
  isOpen: boolean;
  onClose: () => void;
  label: string;
  onChangeValue: (event: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  onCancel: () => void;
  value?: string;
}

const NewItemDialog = ({
  isOpen,
  onClose,
  label,
  value,
  onChangeValue,
  onSubmit,
  onCancel,
}: NewItemDialogProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          padding: 8,
          borderRadius: 7,
        },
      }}
    >
      <NewItemFormContainer>
        <Input
          label={label}
          value={value}
          onChange={onChangeValue}
          sx={{
            background: 'white',
          }}
        />
        <Flex flexDirection='column' gap={2}>
          <Button onClick={onSubmit}>
            <FormattedMessage id='misc.create' />
          </Button>
          <Button variant='tertiary' onClick={onCancel}>
            <FormattedMessage id='misc.cancel' />
          </Button>
        </Flex>
      </NewItemFormContainer>
    </Dialog>
  );
};

export default NewItemDialog;
